import { parse, stringify } from "qs";
import { browser, getLang, IS_SERVER, SOCIAL_LINKS } from "../common";
import { translation } from "../translations/templateElements/translation";
import { dispatchPromoCode } from "../api/Registration/api";

/**
 * Вывести число с анимацией счетчика
 * @param {Node} element Элемент, в который необходимо выводить число
 * @param {Number} from Число, с которого начинается отсчет
 * @param {Number} to Конечное число
 * @param {Number} duration Длительность анимации в миллисекундах
 * @param {boolean} isNeedSpace Нужно ли форматирование числа с пробелами, true - нужно, false - число без пробелов
 * @param {Number} start Текущая дата в миллисекундах (new Date().getTime())
 * @constructor
 */
export const AnimatingNumberCounters = (element, from, to, duration, isNeedSpace, start) => {
  setTimeout(() => {
    const now = (new Date().getTime()) - start;
    const progress = now / duration;
    const result = Math.floor((to - from) * progress + from);
    element.innerHTML = isNeedSpace ?
      new Intl.NumberFormat('ru-RU').format(progress < 1 ? result : to) :
      progress < 1 ? result : to;

    progress < 1 && setTimeout(AnimatingNumberCounters(element, from, to, duration, isNeedSpace, start), 10);
  }, 10);
};

/**
 * Счетчик до даты
 * @param {String} Тайминг события по UTC (в формате '13 Jan 2022 00:00 GMT') - для обратного отсчёта до этой даты и времени
 * @return {Object} Объект с таймингом обратного отсчета в днях, часах, минутах, секундах
 */
export const countDownTimeToEvent = (deadlineString) => {
  const deadlineInMilliseconds = Date.parse(deadlineString)
  const now = new Date();
  const diff = deadlineInMilliseconds - now;

  const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
  const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
  const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
  const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;

  return {
    days,
    hours,
    minutes,
    seconds
  }
}

/**
 * Получить соц сеть по названию
 * @param {String} name Название соц сети
 */
export const getSocialLinkByName = name => SOCIAL_LINKS[name];

/**
 * Получить куку
 */
export const getCookie = (name) => {
  const results = !IS_SERVER && document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  if (results) {
    return (unescape(results[2]));
  }
  return null;
}

/**
 * Установить куку
 */
export function setCookie(name, value, options = {}) {
  if (!IS_SERVER) {
    options = {
      path: '/',
      ...options
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }
}

/**
 * Удалить куку
 */
export function deleteCookie(name) {
  if (!IS_SERVER) {
    setCookie(name, "", {
      'max-age': -1
    })
  }
}

export function getCookieByName(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

/**
 * Прокинуть промокод, страну и язык из get параметров в регистрацию через ссылки
 * @param {String} promo_code Промокод
 * @param {Number} country_id ID страны
 * @param {Number} lang_id ID языка
 * @param {Boolean} isRegForm нужна ли форма регистрации
 * @param {Boolean} isLoginForm нужна ли форма авторизации
 * @param {String} selector Селектор для вставки параметров
 * @param {Boolean} isCupis Бренд ЦУПИС / не Цупис - чтоб не передавать для ЦУПИС ненужные параметры (~ country_id / lang_id)
 */
export const throwParamsToSite = (promo_code, country_id, lang_id, isRegForm = false,
  isLoginForm = false, selector = 'a[href*="reg"]', isCupis) => {
  if (IS_SERVER) return
  const getParameters = parse(window.location.search, { ignoreQueryPrefix: true });
  const links = document.querySelectorAll(selector);

  let prevailingPromoCode;
  if (getParameters.hasOwnProperty('promo_code')) {
    prevailingPromoCode = getParameters['promo_code'];
  }

  const arrParams = [];
  const loginFormParam = "login_form";
  const regFormParam = "reg_form";

  const checkUrlHasParam = () => {
    links.forEach(item => {
      const urlHasParam = /[?]/.test(item.href);
      if (item.href && urlHasParam) {
        const param = item.href.split('?')[1];
        arrParams.push(param);
      }
    });
  }

  const defineAlreadyHasThisParam = (array, item) => {
    if (array.indexOf(item) !== -1) {
      return true
    }
    return false
  }

  checkUrlHasParam();

  //WEBDEV-12303
  // const checkPromoCode = (value) => {
  //   const formData = new FormData();
  //   formData.append("promo_code", value);
  //   formData.append("currency_id", '1');
  //   return dispatchPromoCode(formData)
  // };

  if (!prevailingPromoCode) {
    if (!!promo_code) {
      getParameters['promo_code'] = promo_code;
    }
  }
  //WEBDEV-12303
  // else {
  //   checkPromoCode(prevailingPromoCode)
  //     .then(res => {
  //       if (res.data.code === 1) {
  //         getParameters.promo_code = promo_code;
  //       }
  //       addParams();
  //     })
  // }
  if (country_id) {
    getParameters['country_id'] = country_id;
  }
  if (lang_id) {
    getParameters['lang_id'] = lang_id;
  }
  if (!browser().mobile && isRegForm) {
    getParameters['reg_form'] = '';
  }
  if (!browser().mobile && isLoginForm) {
    getParameters['login_form'] = '';
  }
  getParameters['sourceScreen'] = 'landing';

  const addParams = () => {

    for (let i = 0; i < links.length; i++) {

      const urlHasParam = /[?]/.test(links[i].href);
      const getParametersString = stringify(getParameters, { addQueryPrefix: !urlHasParam, strictNullHandling: true });
      const finalGetParametersString = getParametersString.replace(
        `&${loginFormParam}=`, (!defineAlreadyHasThisParam(arrParams, loginFormParam) ? `&${loginFormParam}` : "")
      ).replace(`&${regFormParam}=`, (!defineAlreadyHasThisParam(arrParams, regFormParam) ? `&${regFormParam}` : ""));
      links[i].href += (urlHasParam ? '&' : '') + (isCupis ? getParametersString : finalGetParametersString)
    }
  }
  //WEBDEV-12303
  // !prevailingPromoCode && addParams()
  addParams();
}

/**
 * Прокинуть get параметры в ссылку
 * @return {String} Строка с параметрами
 */

export const throwParamsToLink = () => {
  if (IS_SERVER) return ''
  const getParameters = parse(window.location.search, { ignoreQueryPrefix: true });
  return stringify(getParameters, { addQueryPrefix: true, strictNullHandling: true });
}

/**
 * Получить верстку карточек с популярными событиями
 * @param {String} lang язык ленда
 * @param {Boolean} isAuth Авторизирован ли пользователь
 * @param {Number} countGames Количество выводимых событий
 * @param {Object} data Данные из запроса
 * @returns {string} Строка с версткой карточек
 */
export const getEventCards = (lang, isAuth, countGames, data) => {
  const { games, dict: { eng, cmd: teamsName } } = data;

  const brandName = undefined;

  const betLinkText = `${getLang(translation, brandName, lang, 'betLink')}`;
  const winLabel = `${getLang(translation, brandName, lang, 'winLabel')}`;
  const drawLabel = `${getLang(translation, brandName, lang, 'drawLabel')}`;
  const winSumLabel = `${getLang(translation, brandName, lang, 'winSumLabel')}`;

  let HTMLCardEvent = '';
  let counter = 0;

  for (const key in games) {
    if (counter === countGames) break;

    const currentGame = games[key];
    const { c1_id: idTeam1, c2_id: idTeam2, sid: idSport, lid: idLeague, f_l: coefs } = currentGame;

    const nameTeam1 = eng.cmd[idTeam1].toLowerCase().replaceAll(' ', '-');
    const nameTeam2 = eng.cmd[idTeam2].toLowerCase().replaceAll(' ', '-');
    const nameSport = eng.sport[idSport].toLowerCase().replaceAll(' ', '-');
    const nameLeague = eng.league[idLeague].toLowerCase().replaceAll(' ', '-').replaceAll('.', '');
    const gameUrl = `${browser().mobile ? '/m' : ''}/line/${nameSport}/${idLeague}_${nameLeague}/${key}_${nameTeam1}-${nameTeam2}`;

    const authLink = `<a href='${gameUrl}' class='bet-link'>${betLinkText}</a>`;
    const link = `<a href='${browser().mobile ? '/m' : ''}/?login_form' class='bet-link'>${betLinkText}</a>`;

    HTMLCardEvent += `
        <div class='event-wrapper'>
          <div class='event-title'>${teamsName[idTeam1]} - ${teamsName[idTeam2]}</div>
          <div class='event-coef-wrapper'>
              <div class='event-cf-left event-cf'>${coefs[0].h ? coefs[0].h : '-'}</div>
              <div class='event-cf-center event-cf'>${coefs[1].h ? coefs[1].h : '-'}</div>
              <div class='event-cf-right event-cf'>${coefs[2].h ? coefs[2].h : '-'}</div>
          </div>
          <div class='event-win-wrapper'>
            <div class='event-win-left event-win'>
                <div class='event-win__text'>${winLabel} "${teamsName[idTeam1]}"</div>
                <div class='event-win__money'></div>
                <div class='event-win__footer-text'>${(coefs[0].h !== undefined) ? `${winSumLabel}` : ''}</div>
            </div>
                <div class='event-win-center event-win'>
                <div class='event-win__text'>${drawLabel}</div>
                <div class='event-win__money'></div>
            <div class='event-win__footer-text'>${(coefs[1].h !== undefined) ? `${winSumLabel}` : ''}</div>
            </div>
            <div class='event-win-right event-win'>
                <div class='event-win__text'>${winLabel} "${teamsName[idTeam2]}"</div>
                <div class='event-win__money'></div>
                <div class='event-win__footer-text'>${(coefs[2].h !== undefined) ? `${winSumLabel}` : ''}</div>
            </div>
          </div>
          ${isAuth ? authLink : link}
        </div>
        `;
    counter++;
  }
  return HTMLCardEvent;
};

/**
 * Сконвертировать короткую запись для длинной суммы
 * @param {any} trigger Запись суммы, которую надо сконвертировать
 (по типу может быть любой: число ~ 17000000, строка ~ "17000000 IRR" и др.)
 * @param {Node} htmlElementForSum Элемент, в который необходимо выводить сумму
 * @param {String} currency Валюта
 * @returns {string} Строка с сконвертированной суммой (например, 17000000 IRR => 17kk IRR)
 */
export const transformSum = (trigger, htmlElementForSum, currency) => {
  // outputSum - Переменная для сконвертированной суммы на выходе
  let outputSum

  // triggerItem - Переменная для измерения длины записи суммы (~ 17000000).
  // Нужна для корректного отображения k (/000) или kk (/000000).
  // При этом запись суммы переводится в другой тип данных при необходимости
  let triggerItem

  // numberToTransform - Переменная для числового значения суммы, которую необходимо конвертировать
  let numberToTransform

  if (typeof trigger === "number") {
    triggerItem = trigger.toString();
    numberToTransform = trigger;
  } else if (typeof trigger === "string") {
    triggerItem = trigger;
    numberToTransform = parseInt(trigger);
  } else {
    triggerItem = trigger.value;
    numberToTransform = trigger.value;
  }

  if (triggerItem.length >= 7) {
    const num = numberToTransform / 1000000;
    if (Number.isInteger(num)) {
      outputSum = `${num}kk`
    } else if (num.toString().split('.').pop().length === 1) {
      outputSum = `${parseFloat(num).toFixed(1)}kk`
    } else {
      outputSum = `${parseFloat(num).toFixed(2)}kk`
    }
  } else if (triggerItem.length >= 5 && triggerItem.length < 7) {
    const num = numberToTransform / 1000;
    if (Number.isInteger(num)) {
      outputSum = `${num}k`
    } else if (num.toString().split('.').pop().length === 1) {
      outputSum = `${parseFloat(num).toFixed(1)}k`
    } else {
      outputSum = `${parseFloat(num).toFixed(2)}k`
    }
  }

  htmlElementForSum.textContent = `${outputSum} ${currency}`
}
